import { useMemo } from 'react'
import { useIntl } from 'react-intl'

export const ESIM_IMAGE_ID = 'qooj3ldzuulsgukb3ww4'

export function useLoyaltyEsimImage(): App.Image {
  const intl = useIntl()

  return useMemo(() => ({
    id: ESIM_IMAGE_ID,
    title: intl.formatMessage({
      id: 'by1SDGsyDqAt4uWH2673',
      defaultMessage: 'Free travel eSIM for Société members',
      description: 'Accessible image title for the loyalty eSIM benefit artwork used across loyalty benefit surfaces',
    }),
  }), [intl])
}
